import { useState } from "react";
import { Check, Ticket } from "lucide-react";
import { usePublic } from "@/context/SiteContext";
import { money } from "@/lib/api";
import { CheckoutDialog } from "./CheckoutDialog";

export const SponsorPackages = ({ category }) => {
  const items = usePublic("sponsorships");
  const [sel, setSel] = useState(null);
  if (items === null) return <div className="h-40 animate-pulse paper-card" />;
  const list = category ? items.filter((p) => category.includes(p.category)) : items;
  return (
    <>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="sponsor-packages">
        {list.map((p, i) => (
          <article key={p.id} className={`flex flex-col p-7 transition-transform hover:-translate-y-1 ${i % 3 === 1 ? "bg-tea text-shell" : i % 3 === 2 ? "bg-mustard text-ink" : "bg-shell text-ink"}`} data-testid={`sponsor-package-${p.id}`}>
            <span className={`font-mono text-[10px] uppercase tracking-[0.22em] ${i % 3 === 1 ? "text-mustard" : "text-passion"}`}>{p.category}</span>
            <h3 className="text-2xl font-semibold mt-2">{p.name}</h3>
            <p className="font-display text-4xl mt-4">{money(p.price)}</p>
            <p className={`text-sm mt-3 opacity-80`}>{p.description}</p>
            <ul className="mt-4 space-y-2 flex-1">
              {(p.perks || []).map((k, j) => (
                <li key={j} className="flex gap-2 text-sm"><Check className="w-4 h-4 mt-0.5 shrink-0 text-mas-orange" />{k}</li>
              ))}
            </ul>
            <button onClick={() => setSel(p)} className={`mt-6 ${i % 3 === 1 ? "btn-terra" : "btn-ink"}`} data-testid={`sponsor-package-button-${p.id}`}>Become a sponsor</button>
          </article>
        ))}
      </div>
      <CheckoutDialog item={sel} mode="sponsorship" onClose={() => setSel(null)} />
    </>
  );
};

export const TicketTiers = () => {
  const items = usePublic("ticket_tiers");
  const [sel, setSel] = useState(null);
  if (items === null) return <div className="h-40 animate-pulse paper-card" />;
  if (!items.length) return <p className="text-mas-mute" data-testid="tickets-empty">Tickets will be announced soon.</p>;
  return (
    <>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="ticket-tiers">
        {items.map((t, i) => {
          const soldOut = t.remaining === 0;
          return (
            <article key={t.id} className={`relative ${["bg-tang", "bg-aqua", "bg-quartz"][i % 3]} text-ink p-6 flex flex-col [clip-path:polygon(0_0,100%_0,100%_42%,96%_50%,100%_58%,100%_100%,0_100%,0_58%,4%_50%,0_42%)]`} data-testid={`ticket-tier-${t.id}`}>
              <Ticket className="w-5 h-5" />
              <h3 className="font-serif text-2xl font-bold mt-3">{t.name}</h3>
              <p className="text-sm text-mas-mute mt-2 flex-1">{t.description}</p>
              <div className="flex items-end justify-between mt-5">
                <p className="font-serif text-3xl font-black">{money(t.price, true)}</p>
                {t.remaining != null && <p className="font-mono text-[11px] uppercase text-mas-mute">{t.remaining} left</p>}
              </div>
              <button disabled={soldOut} onClick={() => setSel(t)} className="mt-4 inline-flex justify-center rounded-full bg-ink text-shell px-6 py-3 text-sm font-semibold hover:bg-passion transition-colors disabled:opacity-50" data-testid={`def-street-buy-tickets-button-${t.id}`}>{soldOut ? "Sold out" : "Buy tickets"}</button>
            </article>
          );
        })}
      </div>
      <CheckoutDialog item={sel} mode="ticket" onClose={() => setSel(null)} />
    </>
  );
};
